import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PieChart } from '@mui/x-charts/PieChart';
import exportarEstadosAExcel from './ExcelProductoxEstado';
import { Box, Button, Card, CardContent } from '@mui/material';

const PieEstados = () => {
    const [empresaIdEmpresa, setEmpresaIdEmpresa] = useState(null);
    const [data, setData] = useState([]);
    const [detalle, setDetalle] = useState([]);
    const [error, setError] = useState(null);

    const obtenerProductosPorEstadoURL = 'https://invio.datachile.site/Web/Reportes/ProductoxEstado.php';

    // Obtener `empresa_idEmpresa` desde el localStorage y consultar la API
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('usuario'));
        if (userData?.empresa_idEmpresa) {
            const empresaId = userData.empresa_idEmpresa;
            setEmpresaIdEmpresa(empresaId);
            getProductosPorEstado(empresaId);
        } else {
            setError('No se encontró empresa_idEmpresa en el localStorage.');
        }
    }, []);

    // Función para consultar la API
    const getProductosPorEstado = async (empresaId) => {
        try {
            const response = await axios.post(obtenerProductosPorEstadoURL, {
                empresa_idEmpresa: empresaId,
            });

            if (response.data && typeof response.data === 'object') {
                const apiData = response.data;

                // Formatear los datos para el gráfico
                const formattedData = Object.entries(apiData).map(([estado, productos], index) => ({
                    id: index,
                    value: productos.length,
                    label: estado,
                }));

                setData(formattedData);
                setDetalle(apiData);
            } else {
                setError('Formato de datos inválido recibido de la API.');
            }
        } catch (err) {
            console.error('Error al obtener los datos:', err);
            setError('Hubo un error al conectar con la API. Intenta nuevamente.');
        }
    };

    return (
        <Card
            sx={{
                backgroundColor: '#e3eaf0',
                boxShadow: 3,
                borderRadius: '16px',
                width: 370,
                height: 320,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CardContent sx={{ width: '100%', height: '100%', padding: 1}}>
            <Box sx={{ width: '100%', height: '100%' }}>
                <h2>Estados</h2>
                <Box sx={{ width: '100%', height: "100%", marginTop: -7 }}>
                    <PieChart
                        series={[
                            {
                                data,
                                highlightScope: { fade: 'global', highlight: 'item' },
                                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                outerRadius: 70,
                            },
                        ]}
                        height={320}
                        slotProps={{
                            legend: {
                                direction: 'column',
                                position: { vertical: 'middle', horizontal: 'right' },
                                itemMarkWidth: 10,
                                itemMarkHeight: 10,
                                markGap: 5,
                                itemGap: 5,
                                labelStyle: {
                                    fontSize: 15,
                                },
                            },
                        }}
                    />
                </Box>

                <Button
                    variant="contained"
                    size="small"
                    sx={{ marginTop: -7 }}
                    onClick={() => exportarEstadosAExcel(detalle)}
                >
                    Exportar a Excel
                </Button>
            </Box>
        </CardContent>
     </Card >
    );
};

export default PieEstados;
